import { useQuery } from "@tanstack/react-query";
import { useProject } from "./useProject";
import { ExtractedVariable } from "@/types/variable-mappings";

export function useTemplateVariables(templateId: number | null) {
  const { projectClient, currentProject } = useProject();

  return useQuery({
    queryKey: ["template_variables_v2", currentProject, templateId],
    queryFn: async () => {
      if (!templateId) return [];

      const { data, error } = await (projectClient as any)
        .from("template_variables_v2")
        .select("*")
        .eq("template_id", templateId)
        .eq("project_id", projectClient.getProjectId())
        .order("variable_name");

      if (error) throw error;

      // Transform to ExtractedVariable format
      const extracted: ExtractedVariable[] = (data || []).map((v: any) => ({
        name: v.variable_name,
        placeholder: v.placeholder || `{${v.variable_name}}`,
        occurrences: v.occurrences || 1,
        slides: v.slides ? JSON.parse(v.slides) : [],
        mapped: false, // Will be determined by VariableMappingManager
      }));

      return extracted;
    },
    enabled: !!templateId,
  });
}
